function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(22 78)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#EAF7FF",
  width: 80,
  height: 59,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 0h72a4 4 0 014 4v5H0V4a4 4 0 014-4z",
  fill: "#B2E0FA"
})), /*#__PURE__*/React.createElement("path", {
  d: "M29 82.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0m5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0",
  fill: "#EAF7FF"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(109 78)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#EAF7FF",
  x: 29,
  width: 80,
  height: 59,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.033 33.399c.105-6.18 5.903-11.596 12.21-11.389 3.022-.138 5.861 1.151 8.178 2.963-.99 1.1-2.013 2.16-3.106 3.152-2.78-1.887-6.738-2.424-9.522-.248-3.977 2.697-4.16 9.07-.332 11.973 3.724 3.312 10.762 1.669 11.787-3.403-2.33-.034-4.67 0-6.999-.073-.006-1.365-.013-2.73-.006-4.092 3.897-.011 7.797-.015 11.7.01.234 3.211-.199 6.626-2.21 9.276-3.046 4.2-9.158 5.427-13.927 3.629-4.786-1.787-8.178-6.744-7.773-11.798",
  fill: "#459FED"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#7FCCF7",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 33a1 1 0 110-2h1a1 1 0 110 2H1zm6 0a1 1 0 110-2h1a1 1 0 110 2H7zm6 0a1 1 0 010-2h1a1 1 0 010 2h-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.345 27.756a1 1 0 111.311-1.512l4.66 4.038c.919.891.919 2.545-.041 3.474l-4.619 4a1.001 1.001 0 01-1.31-1.512l4.576-3.962c.109-.105.109-.46.042-.526l-4.619-4z"
})), /*#__PURE__*/React.createElement("path", {
  d: "M33 0h72a4 4 0 014 4v5H29V4a4 4 0 014-4z",
  fill: "#B2E0FA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M36 4.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0m5 0a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0",
  fill: "#EAF7FF"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(49 100)",
  fill: "#459FED"
}, /*#__PURE__*/React.createElement("rect", {
  y: 14,
  width: 4,
  height: 10,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 7,
  y: 8,
  width: 4,
  height: 16,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 10,
  width: 4,
  height: 14,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 21,
  width: 4,
  height: 24,
  rx: 1
})));

function SvgGoogleDataStudioIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 144
  }, props), _ref);
}

export default "data:image/svg+xml,%3Csvg width='240' height='144' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(22 78)'%3E%3Crect fill='%23EAF7FF' width='80' height='59' rx='4'/%3E%3Cpath d='M4 0h72a4 4 0 0 1 4 4v5H0V4a4 4 0 0 1 4-4z' fill='%23B2E0FA'/%3E%3C/g%3E%3Cpath d='M29 82.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M34 82.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0' fill='%23EAF7FF'/%3E%3Cg transform='translate(109 78)'%3E%3Crect fill='%23EAF7FF' x='29' width='80' height='59' rx='4'/%3E%3Cpath d='M57.033 33.399c.105-6.18 5.903-11.596 12.21-11.389 3.022-.138 5.861 1.151 8.178 2.963-.99 1.1-2.013 2.16-3.106 3.152-2.78-1.887-6.738-2.424-9.522-.248-3.977 2.697-4.16 9.07-.332 11.973 3.724 3.312 10.762 1.669 11.787-3.403-2.33-.034-4.67 0-6.999-.073-.006-1.365-.013-2.73-.006-4.092 3.897-.011 7.797-.015 11.7.01.234 3.211-.199 6.626-2.21 9.276-3.046 4.2-9.158 5.427-13.927 3.629-4.786-1.787-8.178-6.744-7.773-11.798' fill='%23459FED'/%3E%3Cg fill='%237FCCF7' fill-rule='nonzero'%3E%3Cpath d='M1 33a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2H1zm6 0a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2H7zm6 0a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2h-1z'/%3E%3Cpath d='M15.345 27.756a1 1 0 1 1 1.311-1.512l4.66 4.038c.919.891.919 2.545-.041 3.474l-4.619 4a1.001 1.001 0 0 1-1.31-1.512l4.576-3.962c.109-.105.109-.46.042-.526l-4.619-4z'/%3E%3C/g%3E%3Cpath d='M33 0h72a4 4 0 0 1 4 4v5H29V4a4 4 0 0 1 4-4z' fill='%23B2E0FA'/%3E%3Cpath d='M36 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M41 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0' fill='%23EAF7FF'/%3E%3C/g%3E%3Cg transform='translate(49 100)' fill='%23459FED'%3E%3Crect y='14' width='4' height='10' rx='1'/%3E%3Crect x='7' y='8' width='4' height='16' rx='1'/%3E%3Crect x='14' y='10' width='4' height='14' rx='1'/%3E%3Crect x='21' width='4' height='24' rx='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
export { SvgGoogleDataStudioIllustration as ReactComponent };